import { CardWrapper, CardTitle } from "./styles";

interface CardProps {
  title?: string;
  disabled?: boolean;
  children?: React.ReactNode;
}

function Card({ title, disabled, children, ...otherProps }: CardProps) {
  return (
    <CardWrapper disabled={!!disabled} {...otherProps}>
      {title && <CardTitle>{title}</CardTitle>}

      {!disabled && <>{children}</>}
    </CardWrapper>
  );
}
export default Card;
